class ProductCategoryViewController extends EntityListViewController
{
    static newInstance<T extends ProductCategoryViewController>(this: new(id: string) => T): T {
        let vc = new this("product-category-list-view");
        (vc as any).initWithResource("layout/product_category/ProductCategoryListView.html");
        return vc;
    }

    parentCategoryID = null;
    parentCategoryName = null;
    category:ProductCategory = null;
    
    protected addButton:MUIButton = null;
    protected clearButton:MUIButton = null;
        
    viewDidLoad(){
        super.viewDidLoad();
        
        this.addButton = MUIOutlet(this, 'add-btn', 'MUIButton');
        this.addButton.setAction(this, function (this:ProductCategoryListViewController){
            AppHelper.sharedInstance().showAddProductCategory( null, (category:ProductCategory) => {
                this.category = category;
                this.didCategoryAdded( category );
             });    
        });

        this.clearButton = MUIOutlet(this, 'clear-btn', 'MUIButton');
        this.clearButton.setAction(this, function (this:ProductCategoryListViewController){
            this.category = null;
            this.didSelectedCategory( null );
        });

        this.searchTextField = MUIOutlet(this, "search-bar", "MUITextField");
        this.setupSearchTextField();

        this.tableView = MUIOutlet(this,"table-view","UITableView");
        this.tableView.dataSource = this;
        this.tableView.delegate = this;
    }

    cellAtIndexPath(tableview:UITableView, indexPath:MIOIndexPath){
        let cell = tableview.dequeueReusableCellWithIdentifier("ProductCategoryCell") as ProductCategoryCell;

        // let item = this.fetchedResultsController.objectAtIndexPath(indexPath) as ProductCategory;
        let item = this.items[indexPath.row] as ProductCategory;
        cell.item = item;

        console.log("NamePath: " + item.namePath);

        cell.selected = (this.selectedItem != null && this.selectedItem.identifier == item.identifier)        
        return cell;
    }
    
    didSelectCellAtIndexPath(tableView:UITableView, indexPath:MIOIndexPath){
        let category = this.items[indexPath.row] as ProductCategory; //this.fetchedResultsController.objectAtIndexPath(indexPath);
        this.didSelectedCategory(category as ProductCategory);
    }

    didSelectedCategory(category:ProductCategory){
        this.selectedItem = category;        
    }

    didCategoryAdded(category:ProductCategory){
        this.selectedItem = category;        
    }

    get fetchedResultsController() {
        if (this._fetchedResultsController != null)
            return this._fetchedResultsController;

        let ad = MUIWebApplication.sharedInstance().delegate;

        let sortDescriptors =  [MIOSortDescriptor.sortDescriptorWithKey("name", true)];
    
        let predicate = [];
        let filterString = null;
        
        if (this.searchString != null) predicate.push('name CONTAINS "' + this.searchString + '"');
        
        if (predicate.length > 0) filterString = predicate.join(' and ');

        let fetchRequest = DBHelper.listFetchRequestWithEntityName("ProductCategory", sortDescriptors, filterString);
        fetchRequest.relationshipKeyPathsForPrefetching = ["image"];
        
        let fetchedResultsController = new MIOFetchedResultsController();        
        fetchedResultsController.initWithFetchRequest(fetchRequest, ad.managedObjectContext, null);
        fetchedResultsController.delegate = this;
    
        fetchedResultsController.performFetch();

        this._fetchedResultsController = fetchedResultsController;
        
        if (fetchedResultsController.fetchedObjects.length > 0) this.mapItems( fetchedResultsController.fetchedObjects as ProductCategory[] );
        
        return this._fetchedResultsController;        
    }

    controllerDidChangeContent(controller:MIOFetchedResultsController){
        this.mapItems( this.fetchedResultsController.fetchedObjects as ProductCategory[] );
        super.controllerDidChangeContent(controller);
    }

    private items:ProductCategory[] = [];
    private mapItems( objects:ProductCategory[]) {
        let sd =  [MIOSortDescriptor.sortDescriptorWithKey("namePath", true)];
        this.items = _MIOSortDescriptorSortObjects(objects, sd );
    }
}

